import type { Phone } from "@finn-no/mobility-dealer-types";
import { Trans, useLingui } from "@lingui/react";
import { useScreenSize } from "@mobility-item-page/client";
import { Intent } from "@mobility-item-page/utilities/client";
import { Button } from "@warp-ds/elements/react/button";
import { toast } from "@warp-ds/elements/toast";
import { useState } from "react";
import { usePulseTracking } from "src/utils/pulseHelper.ts";
import { copyToClipboard } from "../../Utils/copyToClipboard.ts";

interface PhonenumberProps {
  phone?: Phone;
  fixedPhoneNumber?: string;
}

export const Phonenumber = ({ phone, fixedPhoneNumber }: PhonenumberProps) => {
  const { i18n } = useLingui();
  const { isMobile } = useScreenSize();
  const { trackPhone, trackShowPhone } = usePulseTracking();
  const [phoneHidden, setPhoneHidden] = useState(true);
  const [text, setText] = useState<string | undefined>(
    i18n.t({ id: "dealerBrandingLayout.actions.phonenumber.show", message: "Show phone number" }),
  );

  const resolvedPhone = fixedPhoneNumber || phone?.phoneNumberFallback;

  if (!resolvedPhone) {
    return null;
  }

  const onDesktopClick = () => {
    if (phoneHidden) {
      trackShowPhone();
      setPhoneHidden(false);
      setText(resolvedPhone);
    } else {
      trackPhone(Intent.Click, `tel:${resolvedPhone}`);
      copyToClipboard(resolvedPhone);
      toast(
        i18n.t({
          id: "dealerBrandingPage.actions.phonenumber.copied",
          message: "Copied",
        }),
      );
    }
  };

  if (fixedPhoneNumber) {
    return isMobile ? (
      <Button
        variant="secondary"
        fullWidth
        className="whitespace-nowrap"
        href={`tel:${fixedPhoneNumber}`}
        onClick={() => trackPhone(Intent.Call, `tel:${fixedPhoneNumber}`)}
      >
        <Trans id="dealerBrandingPage.actions.phonenumber.call" message="Call seller" />
      </Button>
    ) : (
      <Button variant="secondary" fullWidth className="whitespace-nowrap" onClick={onDesktopClick}>
        {text}
      </Button>
    );
  }
  if (phone) {
    return isMobile ? (
      <Button
        variant="link"
        className="whitespace-nowrap"
        href={`tel:${phone.phoneNumberFallback}`}
        onClick={() => trackPhone(Intent.Call, `tel:${phone.phoneNumberFallback}`)}
      >
        {phone.phoneNumberDirectCallText ? (
          phone.phoneNumberDirectCallText
        ) : (
          <Trans id="dealerBrandingPage.actions.phonenumber.call" message="Call seller" />
        )}
      </Button>
    ) : (
      <Button variant="link" className="whitespace-nowrap" onClick={onDesktopClick}>
        {text}
      </Button>
    );
  }
};
